import { useSelector } from 'react-redux';
import { currentTab } from '../../features/tab/tabSlice';
const tabs = ['قوانین', 'تاریخ و ساعت', 'اطلاعات بیمار', 'اطلاعات سلامت', 'تأیید و پرداخت', 'کد پیگیری'];
export default function Tab() {
    const activeTab = useSelector(currentTab);
    return <nav aria-label="مراحل دریافت نوبت"><ol className="booking-progress">
        {tabs.map((name, index) => <li key={name} className={index === activeTab ? 'is-current' : index < activeTab ? 'is-complete' : ''} aria-current={index === activeTab ? 'step' : undefined}>
            <span className="booking-step-number" aria-hidden="true">{index < activeTab ? '✓' : index + 1}</span><span>{name}</span>
        </li>)}
    </ol></nav>;
}
